<!--<div class="row">
    <div class="col-24">
        <h4><u>Section 6: Please Read This Important Information</u></h4>
    </div>
</div>-->
<div class="row">
    <div class="col-16">
        <p class="bold-font">
            Please read:
        </p>
        <p>
            <strong>If you are a member of a Medicare Advantage Plan</strong> (such as an HMO or
            PPO), you may already have prescription drug coverage from your Medicare Advantage
            Plan that will meet your needs. By joining {{orgName}}, your membership in your Medicare Advantage Plan may end. This will affect both
            your doctor and hospital coverage as well as your prescription drug coverage. Read
            the information that your Medicare Advantage Plan sends you and if you have questions,
            contact your Medicare Advantage Plan.
        </p>
        <p>
            <strong>
                If you currently have health coverage from an employer or union, joining
                {{orgName}} could affect your employer or union health benefits.
            </strong> You could lose
            your employer or union health coverage if you join {{orgName}}.
            Read the communications your employer or union sends you. If you have questions,
            visit their website, or contact the office listed in their communications. If there
            isn’t information on whom to contact, your benefits administrator or the office
            that answers questions about your coverage can help.
        </p>
    </div>
</div>

<div class="row">
    <div class="col-16">
        <label>Notes (max 300 characters) (optional)</label>
        <textarea rows="3" cols="60" name="txtNotes" maxlength="300"
                   [(ngModel)]="enrollment.NOTES" ></textarea>
    </div>
</div>
